import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';
import { Form } from '../general/general-component/abstruct-component/AbstructForm';
import { VariableEvaluation } from './VariableEvaluation';
import { postEvaluationType } from '../../store/Actions/ActionEvaluationType';
import { loadProjectTypes } from '../../store/Actions/ActionProjectType';
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom';
import '../../assets/styles/StylePopup.css'

function AddEvaluationType({ open, setOpen }) {

  const { mode, dispatch, navigate, langLocal } = AbstructVar();

  const { translate } = AbstructLang();

  const { state, setStateCustom, setLoad } = VariableEvaluation();

  const { projectTypes } = useSelectorCustom()
  const [customprojectTypes, setcustomprojectTypes] = useState([])

  useEffect(() => {
    dispatch(loadProjectTypes())
  }, []);
  useEffect(() => {
    console.log(projectTypes)
    if (projectTypes?.length > 0) {
      const temp = projectTypes?.map((item) => ({
        value: item?.id,
        label: item?.name
      }))
      setcustomprojectTypes(temp)
    }
  }, [projectTypes]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postEvaluationType(state, setLoad));
  };

  const formFields = [
    { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
    {
      name: "constraint", label: "Constraint", type: "text", inputType: 'one_select', iconType: "pencil",
      options: [{ value: 'optional', label: 'Optional' }, { value: 'required', label: 'Required' }]
    },
    {
      name: "evaluation_type", label: "Evaluation Type", type: "text", inputType: 'one_select', iconType: "pencil",
      options: [{ value: 'question', label: 'Question' }, { value: 'normal', label: 'Normal' }]
    },
    {
      name: "creative_work_type_id", label: "Project Type", type: "text", inputType: 'one_select', iconType: "pencil",
      options: customprojectTypes
    },
  ];

  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: 'popupR',
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
        <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
          <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('add-evaluation-type')}</p>
        </div>
        <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
      </div>
    </RModal>
  );
}

export default AddEvaluationType;